<template>
    <div>
        <BoxAntecedentes :data="antecedentesData" />
        <BoxSubjetivo :data="subjetivoData" />
        <BoxObjetivo :data="objetivoData" />
        <BoxAvaliacao :data="avaliacaoData" />
        <BoxPlano :data="planoData" />

        <BoxFinalizacao
            :data="finalizacaoData"
            :fila-id="filaId"
            :ficha-avaliacao="fichaAvaliacao"
        />
    </div>
</template>

<script>
// Components.
import BoxAntecedentes from './components/antecedente/Index'
import BoxAvaliacao from './components/avaliacao/Index'
import BoxFinalizacao from './components/finalizacao/Index'
import BoxObjetivo from './components/objetivo/Index'
import BoxPlano from './components/plano/Index'
import BoxSubjetivo from './components/subjetivo/Index'

export default {
    components: {
        BoxAntecedentes,
        BoxAvaliacao,
        BoxFinalizacao,
        BoxObjetivo,
        BoxPlano,
        BoxSubjetivo,
    },
    computed: {
        antecedentesData() {
            return {
                additionals: this.data.additionals,
                form: this.data.form.antecedentes,
                model: this.data.model.antecedentes,
                cidSugestao: this.cidSugestao,
            }
        },
        subjetivoData() {
            return {
                additionals: this.data.additionals,
                avaliacaoForm: this.data.form.avaliacao,
                avaliacaoModel: this.data.model.avaliacao,
                cidSugestao: this.cidSugestao,
                form: this.data.form.subjetivo,
                model: this.data.model.subjetivo,
            }
        },
        objetivoData() {
            return {
                additionals: this.data.additionals,
                avaliacaoModel: this.data.model.avaliacao,
                form: {...this.data.form.objetivo, paciente: this.data.form.paciente},
                model: this.data.model.objetivo,
            }
        },
        avaliacaoData() {
            return {
                additionals: this.data.additionals,
                finalizacaoForm: this.data.form.finalizacao,
                finalizacaoModel: this.data.model.finalizacao,
                form: this.data.form.avaliacao,
                model: this.data.model.avaliacao,
                objetivoModel: this.data.model.objetivo,
                subjetivoModel: this.data.model.subjetivo,
                ociModel: this.data.model.oci,
                cidSugestao: this.cidSugestao,
            }
        },
        planoData() {

            const soapId = this.data.model ? this.data.model.id : null

            return {
                additionals: {
                    ...this.data.additionals,
                    soapId: soapId
                },
                form: this.data.form.plano,
                model: this.data.model.plano,
                feridaModel: this.data.model.feridas,
                ociModel: this.data.model.oci,
                objetivoForm: this.data.form.objetivo,
                objetivoModel: this.data.model.objetivo,
                avaliacaoForm: this.data.form.avaliacao,
                avaliacaoModel: this.data.model.avaliacao,
                cidSugestao: this.cidSugestao,
                procedimentosAdministrativosModel: this.data.model.finalizacao.procedimentosAdministrativos,
            }
        },
        finalizacaoData() {
            return {
                additionals: this.data.additionals,
                form: this.data.form.finalizacao,
                model: this.data.model.finalizacao,
                ociModel: this.data.model.oci,
                cidSugestao: this.cidSugestao,
                procedimentosClinicosModel: this.data.model.plano.procedimentosClinicos,
            }
        },
        cidSugestao() {

            const problemas = this.data.model.antecedentes.problemasCondicoes
                ? this.data.model.antecedentes.problemasCondicoes.filter(item => !item.id)
                : [];
            const motivos = this.data.model.subjetivo.motivos || [];
            const motivosForm = this.data.historicoSoap.subjetivo.motivos || [];
            const problemasCondicoes = this.data.model.avaliacao.problemasCondicoes || [];
            const problemasCondicoesForm = this.data.historicoSoap.avaliacao.problemasCondicoes || [];
            const solicitacoesExamesAltoCusto = this.data.model.plano.solicitacoesExamesAltoCusto || [];
            const solicitacoesExamesAltoCustoForm = this.data.historicoSoap.plano.solicitacoesExamesAltoCusto || [];
            const solicitacoesExamesComuns = this.data.model.plano.solicitacoesExamesComuns || [];
            const solicitacoesExamesComunsForm = this.data.historicoSoap.plano.solicitacoesExamesComuns || [];
            const atestados = this.data.model.plano.atestados || [];
            const atestadosForm = this.data.historicoSoap.plano.atestados || [];
            const encaminhamentos = this.data.model.plano.encaminhamentos || [];
            const encaminhamentosForm = this.data.historicoSoap.plano.encaminhamentos || [];
            const compartilhamentosCuidado = this.data.model.plano.compartilhamentosCuidado || [];
            const compartilhamentosCuidadosForm = this.data.historicoSoap.plano.compartilhamentosCuidados || [];
            const cidEmadForm = this.data.historicoSoap.finalizacao.cidEmad || [];
            const emadCidPrimarioId = this.data.model.finalizacao.emadCidPrimarioId

            const unicosProblemas = new Map();
            problemas.forEach(p => {
                if (p.cid && !unicosProblemas.has(p.cid.id)) {
                    unicosProblemas.set(p.cid.id, p);
                }
            });

            motivos.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            motivosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            problemasCondicoes.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            problemasCondicoesForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

           solicitacoesExamesAltoCusto.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

           solicitacoesExamesAltoCustoForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            solicitacoesExamesComuns.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            solicitacoesExamesComunsForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            atestados.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            atestadosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

           encaminhamentos.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

           encaminhamentosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            compartilhamentosCuidado.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            compartilhamentosCuidadosForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            if (emadCidPrimarioId) {
                emadCidPrimarioId['cid'] = {
                    codigo: emadCidPrimarioId.codigo,
                    id: emadCidPrimarioId.id,
                    nome: emadCidPrimarioId.nome
                }
            }

            if (emadCidPrimarioId && !unicosProblemas.has(emadCidPrimarioId.cid.id)) {
                unicosProblemas.set(emadCidPrimarioId.cid.id, emadCidPrimarioId);
            }

            cidEmadForm.forEach(m => {
                if (m.cid && !unicosProblemas.has(m.cid.id)) {
                    unicosProblemas.set(m.cid.id, m);
                }
            });

            return Array.from(unicosProblemas.values()).map(item => ({
                id: item.cid.id,
                codigoNome: item.cid.codigo + ' - ' + item.cid.nome,
                codigo: item.cid.codigo,
                nome: item.cid.nome
            }));
        }
    },
    props: {
        data: {type: Object, required: true},
        filaId: {type: Number, required: true},
        fichaAvaliacao: {type: Boolean, default: true},
    },
}
</script>